import { useAtomValue } from "jotai";
import {
  patientConsentAtom,
  providerConsentAtom,
} from "../../session/messages/state";
import { TranscriptionPill } from "../../session/TranscriptionPill";
import {
  AudioRecordingState,
  ConsentStatus,
  participantCountAtom,
} from "../../video-sdk";
import { useRecordingControl } from "./useRecordingControl";

export function TranscriptionPillWrapper() {
  const patientConsent = useAtomValue(patientConsentAtom).value;
  const providerConsent = useAtomValue(providerConsentAtom).value;
  const hasMultipleParticipants = useAtomValue(participantCountAtom) > 1;

  const { isVisible, recordingState } = useRecordingControl();

  const bothPartiesConsented =
    patientConsent === ConsentStatus.OPTED_IN &&
    providerConsent === ConsentStatus.OPTED_IN;

  const isRecording = recordingState === AudioRecordingState.RECORDING;

  if (
    !isVisible ||
    !(bothPartiesConsented || isRecording) ||
    hasMultipleParticipants
  ) {
    return null;
  }

  return (
    <TranscriptionPill
      isRecording={isRecording}
      patientConsent={patientConsent}
    />
  );
}
